export const dropConfig = {
  noClick: true,
  maxFiles: 1,
  maxSize: 2000000,
  accept: 'text/html',
  multiple: false,
};
